import { render } from "./ProfileProviderComponent.vue?vue&type=template&id=45ea39fc&scoped=true"
import script from "./ProfileProviderComponent.vue?vue&type=script&lang=js"
export * from "./ProfileProviderComponent.vue?vue&type=script&lang=js"

import "./ProfileProviderComponent.vue?vue&type=style&index=0&id=45ea39fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ea39fc"]])

export default __exports__